module.exports = __webpack_public_path__ + "img/chart-bar-vert-multi.63146c2b.svg";